import { render, staticRenderFns } from "./MovieList.vue?vue&type=template&id=66ad2654&scoped=true&"
import script from "./MovieList.vue?vue&type=script&lang=js&"
export * from "./MovieList.vue?vue&type=script&lang=js&"
import style0 from "./MovieList.vue?vue&type=style&index=0&id=66ad2654&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66ad2654",
  null
  
)

component.options.__file = "MovieList.vue"
export default component.exports